// Validates the video / Drive link entered on ad delivery.
// Primary goal: reject Google Drive *folder* links — people keep pasting the
// folder instead of the individual video's file link, which breaks downstream
// download/handoff. Non-Drive URLs (direct .mp4, other hosts) are left alone.

const GOOGLE_DRIVE_HOST = /(?:drive|docs)\.google\.com/i;
const DRIVE_FOLDER_PATH = /\/folders\//i;

/** True if the URL is a Google Drive folder link (the mistake we're guarding against). */
export function isDriveFolderUrl(raw) {
  const url = (raw || "").trim();
  return GOOGLE_DRIVE_HOST.test(url) && DRIVE_FOLDER_PATH.test(url);
}

/**
 * Validate an ad asset URL.
 * @returns {{ ok: boolean, error: string }} — `error` is "" when empty (no inline
 *   message; the field's required-ness is handled by the caller / disabled button).
 */
export function validateAssetUrl(raw) {
  const url = (raw || "").trim();
  if (!url) return { ok: false, error: "" };

  if (!/^https?:\/\//i.test(url)) {
    return { ok: false, error: "Enter a full URL starting with http:// or https://" };
  }
  if (isDriveFolderUrl(url)) {
    return {
      ok: false,
      error:
        "This looks like a Drive folder link. Open the video inside the folder and paste that file's link (…/file/d/…).",
    };
  }
  return { ok: true, error: "" };
}
